import Cookie, { CookieSetOptions } from 'universal-cookie';

const cookies = new Cookie();

const getAccessToken = (): string => {
  return cookies.get('accessToken') as string;
};

const getSignedInEmail = (): string => {
  return cookies.get('email') as string;
};

const cookieOptions: CookieSetOptions = {
  path: '/',
  sameSite: 'none',
  secure: true,
  domain: process.env.REACT_APP_COOKIE_DOMAIN
};

const setAccessTokenToCookie = (accessToken: string): void => {
  cookies.set('accessToken', accessToken, cookieOptions);
};

const removeAccessTokenFromCookie = (): void => {
  cookies.remove('accessToken', cookieOptions);
};

const getHomeAccountId = (): string => {
  return cookies.get('homeAccountId') as string;
};

const removeHomeAccountIdFromCookie = (): void => {
  cookies.remove('homeAccountId', cookieOptions);
};

const setIdTokenToCookie = (idToken: string): void => {
  cookies.set('idToken', idToken, cookieOptions);
};

const removeIdTokenFromCookie = (): void => {
  cookies.remove('idToken', cookieOptions);
};

const removeEmailFromCookie = (): void => {
  cookies.remove('email', cookieOptions);
};

const clearAllCookies = (): void => {
  removeAccessTokenFromCookie();
  removeIdTokenFromCookie();
  removeHomeAccountIdFromCookie();
  removeEmailFromCookie();
};

export {
  getAccessToken,
  setAccessTokenToCookie,
  removeAccessTokenFromCookie,
  clearAllCookies,
  getHomeAccountId,
  removeHomeAccountIdFromCookie,
  setIdTokenToCookie,
  getSignedInEmail
};
